import { useCallback } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { getDateString } from '../../utils/date-helpers';
import { useCalendarDeepLinkParams } from './use-calendar-deep-link-params';

export const useViewEventOnCalendar = () => {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as { eventId?: string };
  const { deepLinkedEventId } = useCalendarDeepLinkParams();

  const viewOnCalendar = useCallback(
    (eventId: string | undefined, eventDate: string | undefined) => {
      if (!eventId || !eventDate) return;

      // Navigate twice to force the deep-link scroll to re-fire even when the same
      // eventId is already in the URL. The setTimeout breaks React's render batching
      // so the card sees eventId cleared before the new value is set.
      if (deepLinkedEventId === eventId) {
        navigate({
          to: '/schedule/calendar',
          search: { ...search, eventId: undefined },
          replace: true,
        });
      }

      setTimeout(() => {
        navigate({
          to: '/schedule/calendar',
          search: { ...search, eventId, currentDate: getDateString(eventDate) },
        });
      }, 0);
    },
    [navigate, search, deepLinkedEventId]
  );

  return { viewOnCalendar };
};
